const picture = {
  init(): void {
    document.querySelectorAll<HTMLElement>('.picture:not(.picture--eager)').forEach((target: HTMLElement, index) => {
      this.loadPicture(target, index)
    })
  },

  loadPicture(target, index): void {
    const image = target.querySelector('img')
    const imageSrc = image.dataset.src
    let imageLoaded = false

    const initialTransitionDelay = document.querySelector('.hero') ? 0.2 : 0
    const transitionDelay = `${initialTransitionDelay + index * 0.1}s`

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !imageLoaded) {
            const loadingImage = new Image()

            loadingImage.onload = () => {
              image.src = loadingImage.src
              target.classList.add('picture--loaded')
              target.style.transitionDelay = transitionDelay
              imageLoaded = true
            }

            loadingImage.src = imageSrc
          }
        })
      },
      {
        root: null,
        rootMargin: `${window.innerHeight / 4}px`,
        threshold: 0,
      }
    )

    observer.observe(image)
  },
}

export default picture
